export enum UISortingOrder {
  ASCENDING = "Asce",
  DESCENDING = "Desc"
}